// extracted by mini-css-extract-plugin
export default {"registration":"Registration_registration__iWFLK","inputName":"Registration_inputName__ZkQAY","btnLogin":"Registration_btnLogin__171-I","main":"Registration_main__PE5hH"};